export type NewsBlock = {
  type: 'p' | 'h2' | 'img';
  text?: string;
  src?: string;
  caption?: string;
};

export type NewsArticle = {
  id: string;
  title: string;
  section: string;
  date: string;
  author: string;
  summary: string;
  cover: string;
  tags: string[];
  body: NewsBlock[];
};

export const newsSections: string[] = ['行业观察', '新片速递', '片场手记', '榜单数据'];

export const newsList: NewsArticle[] = [
  {
    id: 'autumn-lineup-2026',
    title: '2026 秋季档前瞻：日韩新片题材正在往「慢」走',
    section: '行业观察',
    date: '2026-10-16',
    author: '编辑部 · 林澈',
    summary: '从已公布的秋季片单来看，长镜头、少对白、实景拍摄成为今年日韩新片最明显的共同倾向。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20vintage%20cinema%20auditorium%20with%20deep%20red%20velvet%20seats%20and%20a%20single%20warm%20projector%20beam%20cutting%20through%20dust%2C%20moody%20atmospheric%20lighting%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20subtle%20grain&width=800&height=500&seq=news-autumn-31&orientation=landscape',
    tags: ['秋季档', '行业趋势', '片单'],
    body: [
      {
        type: 'p',
        text: '九月底开始，日本与韩国两地的秋季片单陆续公布。与过去两年强调强情节与快节奏不同，今年公布的作品里，超过一半选择了更缓慢的叙事方式：长时间固定镜头、少量对白、大量实景拍摄。',
      },
      {
        type: 'h2',
        text: '实景拍摄比例明显上升',
      },
      {
        type: 'p',
        text: '在可查的公开资料中，多部新片把主要拍摄地放在老旧公寓、地方旅馆与即将停业的商铺。制片方给出的理由很实际：实景比搭景便宜，而且画面更容易被观众记住。',
      },
      {
        type: 'img',
        src: 'https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20shot%20of%20a%20film%20crew%20lighting%20a%20small%20apartment%20set%20at%20night%2C%20softboxes%20and%20cables%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20documentary%20style%20editorial%20photography%2C%20grain&width=800&height=500&seq=news-autumn-32&orientation=landscape',
        caption: '夜间实景拍摄成为今年秋季档的常见工作方式。',
      },
      {
        type: 'p',
        text: '这种变化直接影响了影片的观感。观众在评论里最常提到的词从「刺激」变成了「安静」，而安静恰恰意味着更高的注意力门槛。',
      },
      {
        type: 'h2',
        text: '题材分布：剧情与悬疑仍是主力',
      },
      {
        type: 'p',
        text: '从分类占比看，剧情类仍占据最大的份额，悬疑类次之。恋爱题材的数量有所下降，但单部作品的制作周期普遍变长，后期调色的投入明显提高。',
      },
      {
        type: 'p',
        text: '对普通观众来说，最直接的变化是片长。今年秋季档的平均片长比去年同期增加了约十一分钟，这意味着选择影片时更需要留意自己当晚的时间安排。',
      },
    ],
  },
  {
    id: 'greenhouse-review',
    title: '《玻璃温室》为什么值得二刷：三条藏在画面里的线索',
    section: '新片速递',
    date: '2026-10-13',
    author: '影评人 · 苏昀',
    summary: '第二次观看时才会注意到的浇水时间、植物形状和那面始终没有擦干净的玻璃，构成了整部影片真正的答案。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20condensation%20covered%20glass%20panels%20in%20a%20greenhouse%2C%20green%20leaves%20silhouetted%20behind%20the%20glass%2C%20moody%20dim%20light%2C%20deep%20olive%20and%20wine%20red%20tones%2C%20atmospheric%20editorial%20photography%2C%20fine%20grain&width=800&height=500&seq=news-greenhouse-33&orientation=landscape',
    tags: ['影评', '悬疑', '细节解读'],
    body: [
      {
        type: 'p',
        text: '《玻璃温室》上映之后，讨论最多的是结尾的反转。但真正让这部影片成立的东西，其实在第一次反转之前就已经全部给出了。',
      },
      { type: 'h2', text: '一、浇水的时间从来不是随机的' },
      {
        type: 'p',
        text: '影片中出现了七次浇水，每一次的时钟都停在同一个时刻。第一次看会觉得这是导演在强调人物生活的规律性，看完之后再回想，这个时刻正好对应档案上的日期。',
      },
      { type: 'h2', text: '二、被修剪成同样形状的植物' },
      {
        type: 'p',
        text: '温室里所有植物都被剪成相同的形状，只有角落那一盆例外。它长得很难看，枝叶乱长，但它是唯一活着的、真实存在过的东西。',
      },
      {
        type: 'img',
        src: 'https://readdy.ai/api/search-image?query=cinematic%20shot%20of%20a%20single%20untidy%20potted%20plant%20in%20the%20corner%20of%20a%20dim%20glass%20greenhouse%2C%20soft%20dusty%20light%20from%20above%2C%20muted%20green%20and%20warm%20brown%20palette%2C%20tasteful%20atmospheric%20film%20still&width=800&height=500&seq=news-greenhouse-34&orientation=landscape',
        caption: '角落里的那一盆，是整部影片唯一没有被修剪过的植物。',
      },
      { type: 'h2', text: '三、从来没有擦干净的玻璃' },
      {
        type: 'p',
        text: '温室玻璃上的水汽从头到尾都没有被擦掉。导演在采访里提到，这是刻意保留的：人物看不到外面，观众也看不到里面，谁都没有比谁更清楚。',
      },
      {
        type: 'p',
        text: '如果你还没看过这部片，建议第一次不要暂停，第二次再逐帧看画面。它的乐趣不在答案，而在过程。',
      },
    ],
  },
  {
    id: 'seoul-night-shoot',
    title: '片场手记：在首尔拍夜戏的六个小时',
    section: '片场手记',
    date: '2026-10-09',
    author: '特约记者 · 郑一',
    summary: '一个镜头、一条街、两台机器，我们跟着剧组从凌晨一点拍到天亮，记录下夜戏真实的成本。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20night%20behind%20the%20scenes%20photo%20of%20a%20film%20crew%20on%20a%20rainy%20Seoul%20street%2C%20camera%20rig%20and%20softbox%20light%2C%20neon%20signs%20reflected%20on%20wet%20pavement%2C%20moody%20teal%20and%20crimson%20tones%2C%20documentary%20editorial%20photography%2C%20grain&width=800&height=500&seq=news-seoul-set-35&orientation=landscape',
    tags: ['片场', '夜戏', '幕后'],
    body: [
      {
        type: 'p',
        text: '凌晨一点，首尔麻浦区的一条支路被临时封闭。剧组要在这里拍一个不到两分钟的镜头，预计需要六个小时。',
      },
      { type: 'h2', text: '为什么夜戏这么慢' },
      {
        type: 'p',
        text: '白天拍一条街，最大的变量是天气。夜里拍同一条街，变量变成了车、行人、店铺灯光和邻居的投诉。每一次调整机位，都要重新确认一遍路灯的色温。',
      },
      {
        type: 'p',
        text: '现场制片说，这条街他们申请了三个晚上的拍摄许可，实际只用上了两个。第三个晚上的预算省下来，补进了后期的调色。',
      },
      {
        type: 'img',
        src: 'https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20a%20film%20camera%20monitor%20on%20a%20night%20street%20set%20showing%20a%20warm%20tone%20image%2C%20gloved%20hands%20adjusting%20focus%2C%20deep%20blue%20night%20ambient%20with%20red%20practical%20light%2C%20documentary%20style%2C%20fine%20grain&width=800&height=500&seq=news-seoul-set-36&orientation=landscape',
        caption: '监视器前的每一次微调，都是六个小时里的一部分。',
      },
      { type: 'h2', text: '天亮之前的最后一条' },
      {
        type: 'p',
        text: '五点半，天边开始泛白，导演决定拍最后一条。这一条没有任何对白，只有人物走过斑马线的背影。拍完之后，全组在路边吃了早餐。',
      },
      {
        type: 'p',
        text: '这大概就是夜戏最真实的部分：观众看到的三十秒，背后是一整夜的搬运、等待和重来。',
      },
    ],
  },
  {
    id: 'weekly-ranking-41',
    title: '本周榜单：剧情类回归，三部新片进入前十',
    section: '榜单数据',
    date: '2026-10-06',
    author: '数据组 · 何夕',
    summary: '第 41 周站内热度榜单公布，《玻璃温室》《首尔凌晨三点》《雨夜的告白》占据前三，剧情类整体热度回升。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20abstract%20data%20visualization%20of%20warm%20crimson%20and%20amber%20bars%20and%20lines%20floating%20over%20a%20dark%20theatre%20background%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20tech%20aesthetic%2C%20high%20detail&width=800&height=500&seq=news-ranking-37&orientation=landscape',
    tags: ['榜单', '热度', '周报'],
    body: [
      {
        type: 'p',
        text: '本周站内热度榜前十名中，剧情类占据四席，为近三个月最高。悬疑类仍保持稳定，恋爱类则因为新片供应减少，热度小幅回落。',
      },
      { type: 'h2', text: '前三名与上周对比' },
      {
        type: 'p',
        text: '《玻璃温室》连续第二周排名第一，收藏量增幅达到 18%。《首尔凌晨三点》从第四升至第二，主要增长来自移动端。《雨夜的告白》保持第三。',
      },
      {
        type: 'p',
        text: '值得注意的是三部新片同时进入前十，其中两部属于新人映画类别，说明观众对新面孔的接受度正在提高。',
      },
      { type: 'h2', text: '关于数据的说明' },
      {
        type: 'p',
        text: '站内榜单依据浏览量、收藏量与页面停留时长综合计算，每日更新，不涉及任何付费推广。榜单仅反映站内浏览情况，不代表影片的实际质量评价。',
      },
    ],
  },
  {
    id: 'rain-sound-design',
    title: '一场雨要怎么录：声音设计师谈《雨夜的告白》',
    section: '片场手记',
    date: '2026-09-29',
    author: '特约记者 · 沈青',
    summary: '整部影片只有一间公寓、两个人，但声音轨道多达七十四层。我们和声音设计师聊了聊「雨」是怎么被造出来的。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20rain%20droplets%20running%20down%20a%20dark%20window%20with%20blurred%20warm%20city%20lights%20behind%2C%20shallow%20depth%20of%20field%2C%20moody%20crimson%20and%20amber%20bokeh%2C%20atmospheric%20editorial%20photography%2C%20fine%20grain&width=800&height=500&seq=news-rain-sound-38&orientation=landscape',
    tags: ['声音设计', '幕后', '剧情'],
    body: [
      {
        type: 'p',
        text: '《雨夜的告白》几乎没有配乐，所有情绪都靠环境声推进。声音设计师在采访中给出的数字是：全片共有七十四层声音轨道。',
      },
      { type: 'h2', text: '雨不是一种声音' },
      {
        type: 'p',
        text: '落在铁皮雨棚上的雨、落在积水里的雨、隔着玻璃听到的雨，是完全不同的三种东西。影片里每一次情绪转折，窗外的雨声都会换一层。',
      },
      {
        type: 'p',
        text: '最麻烦的是「安静」。为了让观众在安静里也能感到不安，设计师在低频里保留了一层几乎听不见的电流声。',
      },
      {
        type: 'img',
        src: 'https://readdy.ai/api/search-image?query=cinematic%20shot%20of%20an%20audio%20mixing%20console%20in%20a%20dark%20studio%20with%20warm%20amber%20fader%20lights%2C%20rain%20visible%20through%20the%20window%20behind%2C%20moody%20atmospheric%20editorial%20photography%2C%20subtle%20grain&width=800&height=500&seq=news-rain-sound-39&orientation=landscape',
        caption: '混音棚里的七十四层轨道，最终只呈现为一种「雨」。',
      },
      {
        type: 'p',
        text: '如果你想感受这些细节，建议戴耳机看第二遍。很多在手机外放里消失的东西，会在耳机里重新出现。',
      },
    ],
  },
  {
    id: 'newcomer-wave',
    title: '新人演员的窗口期：从练习生到银幕的十二个月',
    section: '行业观察',
    date: '2026-09-22',
    author: '编辑部 · 林澈',
    summary: '新人映画类别的更新频率在两年内翻了一倍。我们梳理了新人演员从公开选拔到首部主演作品的常见路径。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%20rehearsal%20room%20with%20mirrors%20and%20a%20single%20warm%20spotlight%2C%20wooden%20floor%2C%20folding%20chairs%2C%20moody%20amber%20and%20deep%20red%20tones%2C%20editorial%20film%20photography%2C%20fine%20grain&width=800&height=500&seq=news-newcomer-40&orientation=landscape',
    tags: ['新人', '行业', '数据'],
    body: [
      {
        type: 'p',
        text: '在日韩两地的制作体系中，新人演员从公开选拔到首部主演作品，平均需要十二个月。这个周期在近两年被明显压缩。',
      },
      { type: 'h2', text: '更短的培训，更长的观察期' },
      {
        type: 'p',
        text: '制作方倾向于先用配角或短片测试观众反应，再决定是否投入主演资源。这意味着新人作品的数量变多了，但单部的宣传预算并没有同步增加。',
      },
      {
        type: 'p',
        text: '对观众而言，最直接的影响是新人映画类别的更新速度变快，同时作品质量差异也变得更大。我们会继续在片单里标注制作信息，方便你判断。',
      },
    ],
  },
  {
    id: 'archive-restoration',
    title: '老片修复潮：为什么这批经典作品被重新调色',
    section: '行业观察',
    date: '2026-09-15',
    author: '编辑部 · 苏昀',
    summary: '修复不是简单地把画面变清晰。调色、声音重制、画幅还原，每一步都可能改变一部老片的气质。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20old%2035mm%20film%20strips%20and%20a%20film%20scanner%20in%20a%20dark%20archive%20room%2C%20warm%20amber%20task%20light%2C%20dust%20particles%2C%20nostalgic%20editorial%20photography%2C%20high%20detail%2C%20fine%20grain&width=800&height=500&seq=news-restoration-41&orientation=landscape',
    tags: ['修复', '经典重制', '档案'],
    body: [
      {
        type: 'p',
        text: '近两年，越来越多的昭和时期作品被重新修复并上线。修复团队通常由调色师、声音工程师和档案管理员组成，一部两小时的影片平均需要三个月。',
      },
      { type: 'h2', text: '「还原」其实是一个选择题' },
      {
        type: 'p',
        text: '原始胶片的色彩早已偏移，所谓还原，更多是参考同时期的剧照、海报和放映记录，重新建立一个可信的基准。这个过程没有唯一正确答案。',
      },
      {
        type: 'p',
        text: '这也是为什么同一部老片的不同修复版本，看起来会像两部不同的电影。观看时可以留意画面整体的色温，它往往反映了修复团队的理解。',
      },
    ],
  },
  {
    id: 'weekend-watchlist',
    title: '周末片单：五部适合一个人看完的慢节奏作品',
    section: '新片速递',
    date: '2026-09-08',
    author: '编辑部 · 何夕',
    summary: '不需要连续追剧情，也不依赖强冲突。这五部作品的共同点是：适合在安静的晚上，一次看完。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20cozy%20night%20scene%20of%20a%20living%20room%20with%20a%20small%20television%20glow%2C%20rain%20on%20the%20window%2C%20warm%20lamp%20and%20a%20cup%20on%20the%20table%2C%20muted%20crimson%20and%20amber%20palette%2C%20tasteful%20editorial%20photography%2C%20soft%20grain&width=800&height=500&seq=news-weekend-42&orientation=landscape',
    tags: ['片单', '推荐', '周末'],
    body: [
      {
        type: 'p',
        text: '这份片单不考虑热度，只考虑观看体验。五部作品的共同点是节奏慢、对白少、画面稳定，适合在周末的晚上一次看完。',
      },
      { type: 'h2', text: '推荐顺序' },
      {
        type: 'p',
        text: '先从《海边旧唱片》开始，片长最短，情绪也最轻。接着是《雪国旅馆》和《午后果园》，最后两部留给《昭和残照》和《玻璃温室》。',
      },
      {
        type: 'p',
        text: '如果只想看一部，选《雪国旅馆》。它的节奏最稳，也最不容易让人中途分心。',
      },
    ],
  },
];